export function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = function (e) {
      resolve(reader.result as string)
    }
    reader.readAsDataURL(blob)
  })
}
